import React, { Component, Fragment } from 'react'
import DashboardLayout from '../components/Admin/DashboardLayout'
import {
  MDBBtn,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../components/content/MDB4Datatable/MDB4Datatable.component'
import AdminApi from '../api/admin-api/admin-api'
import { toast } from 'react-toastify'

class AdminDashboardCarrierContests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contestList: '',
      loading: '',
      error: '',
      modal: false,
      confirmModal: false,
      viewdata: '',
      pagination: { page: 0, per_page: 10 },
      data: {
        columns: [
          {
            label: 'Contest Name',
            field: 'name',
            sort: 'asc',
            width: 200,
          },
          {
            label: 'Contest Banner',
            field: 'banner',
            sort: 'disabled',
            width: 150,
          },
          {
            label: 'Edit',
            field: 'edit',
            sort: 'disabled',
            width: 100,
          },
          {
            label: 'Delete',
            field: 'delete',
            sort: 'disabled',
            width: 100,
          },
        ],
        rows: [],
      },
    } // state end
  }

  componentDidMount() {
    this.fetchContestData()
  }

  //convert date from sec to current date
  toDateTime = secs => {
    let t = new Date(1970, 0, 1) // Epoch
    t.setSeconds(secs)
    return t
  }

  //toggle modal
  toggle = () => {
    this.setState({ modal: !this.state.modal })
  }

  //calling delete confirm modal
  confirm_DeleteContest = data => {
    this.confirm_toggle(data)
  }

  //Toggle delete confirm modal
  confirm_toggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  //forming rows for data table from fetched data
  setRows = () => {
    const { contestList } = this.state
    if (contestList && contestList.length) {
      let rows = contestList.map(row => {
        // const {ls_name, created_at, docId} = row;
        const { con_name, con_image, id } = row
        // const submittedDate = created_at && this.toDateTime(created_at._seconds).toString();
        const self = this

        function editContest() {
          self.props.history.push(`/add-carrier-contests/${id}/edit`)
        }

        function deleteContest() {
          self.confirm_DeleteContest({ viewdata: row })
        }

        const editClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={editContest}>
              <MDBIcon icon='edit' size='2x' className='blue-text p-1' />
            </div>
          </div>
        )

        const deleteClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={deleteContest}>
              <MDBIcon icon='trash' size='2x' className='red-text p-1' />
            </div>
          </div>
        )

        const banner = <img src={con_image} className='mx-auto d-block' style={{ height: '50px' }} alt='' />

        return {
          name: con_name,
          // created: submittedDate,
          banner: banner,
          edit: editClick,
          delete: deleteClick,
        }
      })
      this.setState({
        data: { ...this.state.data, rows: rows },
      })
    }
  }

  //Fetch data
  fetchContestData = async () => {
    this.setState({ loading: true })

    AdminApi.getCarrierContests()
      .then(result => {
        this.setState({ contestList: result.data.data || [], loading: false }, () => this.setRows())
      })
      .catch(error => {
        this.setState({ loading: false })
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  //Delete data
  _DeleteContest = async id => {
    this.setState({ deleting: true })
    const data = { type: 'carrier_contests', id: id }

    AdminApi.deleteContest(data)
      .then(result => {
        this.setState({ deleting: false })
        this.confirm_toggle()
        toast.success('Contest successfully deleted', {
          position: toast.POSITION.TOP_RIGHT,
        })
        this.fetchContestData()
      })
      .catch(error => {
        this.setState({ deleting: false })
        toast.error(`${error.message}`, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  render() {
    toast.configure()
    const { data, confirmModal, loading } = this.state

    const createNew = () => {
      this.props.history.push('/add-carrier-contests')
    }

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <h2>
                Carrier Contests
                <div className='d-inline-block'>
                  <MDBBtn type='button' tag='a' floating gradient='blue' title={'Add Contest '} onClick={createNew}>
                    <MDBIcon icon='plus' />
                  </MDBBtn>
                </div>
              </h2>
              <hr />
              {loading ? (
                <h4 className={'p4'}>Loading...</h4>
              ) : (
                <div className='content-wrapper' id='carrier-contests-page'>
                  <MDB4Datatable data={data} striped bordered small className='text-capitalize' />
                </div>
              )}

              <MDBModal open={confirmModal} tabIndex='-1' onClose={this.confirm_toggle}>
                <MDBModalDialog size={'sm'}>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirm_toggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className='h5'>Are you sure you want to delete this Contest?</div>
                      <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirm_toggle}>
                        Close
                      </MDBBtn>
                      <MDBBtn
                        type='button'
                        color='danger'
                        size={'sm'}
                        onClick={() => {
                          this._DeleteContest(this.state.viewdata.id)
                        }}
                      >
                        {this.state.deleting ? 'Deleting...' : 'Delete'}
                      </MDBBtn>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AdminDashboardCarrierContests
